import { createAsyncThunk } from '@reduxjs/toolkit';
import { OrderingOperations, OrderingSelectors } from 'polygon-ordering';
import debug from '../utils/debug';
import { logUser } from '../utils/analytics';
import type { RootState } from '../store';
import { fetchProfile } from './fetchProfile';
import checkAuthTokenPresent from '../utils/checkAuthTokenPresent';
import { fetchLoyaltyTiers } from './fetchLoyaltyTiers';
import { setUserLogout } from '../slices/userLogout';

const { fetchMember, removeMember, setAgeProofSubmitted, setUserUnderage } = OrderingOperations;
const { getMember } = OrderingSelectors;

export const syncMember = createAsyncThunk(
  'syncMember',
  async (_data: undefined, { dispatch, getState, rejectWithValue }) => {
    const authPresent = checkAuthTokenPresent();
    debug('syncing member', { authPresent });

    const resetAgeProof = () => {
      dispatch(setAgeProofSubmitted(false));
      dispatch(setUserUnderage(false));
    };

    try {
      if (!authPresent) {
        const previousMemberData = getMember(getState() as RootState);

        debug('removing member');
        logUser(null);
        dispatch(removeMember());

        if (previousMemberData) resetAgeProof();

        return;
      }

      // below are the sign in events
      dispatch(setUserLogout(false));
      dispatch(fetchProfile());
      dispatch(fetchLoyaltyTiers());

      const previousMemberData = getMember(getState() as RootState);

      if (!previousMemberData) {
        resetAgeProof();
      }

      await dispatch(fetchMember({ authenticationMethod: 'member' }));

      const newMemberData = getMember(getState() as RootState);

      const signedIn = !previousMemberData && newMemberData;
      const changedUser =
        previousMemberData && newMemberData && previousMemberData.id !== newMemberData.id;

      if (changedUser) resetAgeProof();

      if ((signedIn || changedUser) && newMemberData) {
        logUser(newMemberData?.memberNumber, newMemberData);
      }
    } catch (e) {
      debug(false, 'member sync failed', { result: e });
      return rejectWithValue(e);
    }
  },
);
